import { cn } from "utils/commonUtils";

// components/ui/modal/ModalHeader.js
export default function ModalHeader({ className = "", children }) {
    return (
        <div className={`modal-header ${cn("tw-w-full tw-relative tw-justify-center tw-flex-wrap tw-pt-[80px] tw-pl-4 sm:tw-m-auto", className)}`}>
            {children}
        </div>
    );
}